<div *ngIf="authUser" [ngClass]="{ 'blurred': isShowTutorial }" class="container">
    <!-- Header -->
    <div class="header">
        <div class="header-left">
            <div class="logo-section">
                <img src="assets/img/phoenix-1.png" alt="Phoenix" class="header-logo" />
                <div class="logo-text">
                    <span class="logo-title">Phoenix</span>
                    <span class="logo-subtitle">Enhancing Silver Value</span>
                </div>
            </div>
        </div>
        <div class="header-right">
            <h1 class="assessment-title">
                <span class="desktop-only">Resultados de tu autodiagnóstico - </span>Diagnóstico Completado
            </h1>
            <button class="exit-button" (click)="logout()">Salir</button>
        </div>
    </div>


    <!-- Step Navigation Bar -->
    <div class="step-navigation" #progressBarEspaciado>
        <div class="step-item completed">
            <div class="step-header">
                <div class="step-icon">1</div>
                <div class="step-progress-bar">
                    <div class="step-progress-fill" style="width: 100%"></div>
                </div>
            </div>
            <div class="step-info-container">
                <span class="step-text-inline">Análisis presente</span>
                <span class="step-status-inline">Completado</span>
            </div>
        </div>
        <div class="step-item completed">
            <div class="step-header">
                <div class="step-icon">2</div>
                <div class="step-progress-bar">
                    <div class="step-progress-fill" style="width: 100%"></div>
                </div>
            </div>
            <div class="step-info-container">
                <span class="step-text-inline">Análisis futuro</span>
                <span class="step-status-inline">Completado</span>
            </div>
        </div>
        <div class="step-item completed">
            <div class="step-header">
                <div class="step-icon">3</div>
                <div class="step-progress-bar">
                    <div class="step-progress-fill" style="width: 100%"></div>
                </div>
            </div>
            <div class="step-footer-active">
                <span class="step-text-inline">Diagnostico</span>
                <span class="step-status-inline">Completado</span>
            </div>
        </div>
    </div>

    <!-- Loading Content -->
    <div *ngIf="isLoading" class="loading-content">
        <app-loading [userName]="authUser.name.split(' ')[0]" (loadingComplete)="onLoadingComplete()"></app-loading>
    </div>

    <!-- Main Content -->
    <div *ngIf="!isLoading" class="main-content">
        <!-- Wheel of Life Section -->

        <div class="wheel-of-life-section">

            <!-- Info Bar -->
            <div class="info-bar">
                <div class="info-content">
                    <i class="check-icon">✓</i>
                    <span>En 30 días puedes volver a realizar el análisis de tu rueda de la vida.</span>
                </div>
            </div>

            <div class="wheel-container">

                <!-- Main Title -->
                <h1 class="wheel-title">RUEDA DE LA VIDA</h1>

                <!-- Main Description -->
                <div class="main-description">
                    <p>
                        <strong>{{authUser.name.split(' ')[0]}}</strong>, este es el momento ideal para comenzar a
                        construir tu siguiente etapa.
                        El tiempo avanza rápido, y cada decisión que tomes hoy puede multiplicarse en bienestar,
                        propósito y seguridad para el futuro.
                        Has elegido <strong>{{priorityArea}}</strong> como tu eje, y eso marca el punto de partida para
                        diseñar la vida que deseas vivir mañana.
                        Aquí tienes el resumen de tu Círculo de la Vida.
                    </p>
                </div>

                <!-- Chart Section -->
                <div class="chart-section">
                    <div class="radar-chart-wrapper">
                        <app-radar-chart [data]="seriesApply" [showLegend]="false" [events]="eventsSubject.asObservable()"></app-radar-chart>
                        <div class="legend-container">
                            <div 
                                *ngFor="let series of seriesApply; let i = index"
                                class="legend-item"
                                [class.active]="seriesApplyIndex === i"
                                (click)="changeSeriesToShow(i)"
                            >
                                <span class="legend-dot" [style.background-color]="getSeriesColor(i)"></span>
                                <span class="legend-text">{{ series.name }}</span>
                            </div>
                            <div 
                                class="legend-item"
                                [class.active]="seriesApplyIndex === seriesApplyIndexComparative"
                                (click)="changeSeriesToShow(seriesApplyIndexComparative)"
                            >
                                <span class="legend-dot" [style.background-color]="getSeriesColor(seriesApplyIndexComparative)"></span>
                                <span class="legend-text">Comparativo</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Bottom Description -->
                <div class="bottom-description">
                    <p>
                        Tus resultados también muestran que sería valioso trabajar en
                        <strong>{{opportunityAreas}}</strong>, para lograr un desarrollo más equilibrado.
                        Recuerda que ya cuentas con fortalezas en <strong>{{strengthAreas}}</strong>, y esas bases te
                        darán confianza y soporte en cada paso hacia el futuro que deseas.
                        A continuación, encontrarás el detalle de tu análisis en tu Círculo de la Vida.
                    </p>
                </div>
            </div>
        </div>

        <!-- Banner Section -->

        <div class="banner-section" *ngIf="showSalaryBanner">
            <div class="left">
                <p class="title">CONVIERTE TU DIAGNÓSTICO EN ACCIÓN.</p>
                <p class="description">YA DISTE EL PRIMER PASO CON TU RUEDA DE VIDA. AHORA POTENCIA TU PROPÓSITO CON UN
                    PLAN GUIADO Y ACOMPAÑAMIENTO EXPERTO.</p>
            </div>
            <div class="right">
                <button class="banner-button"
                    (click)="isHighSalaryUser ? bannerClickExecutive() : bannerClickProfessional()">
                    Conoce más AQUÍ
                </button>
            </div>
        </div>

        <!-- Analysis Details Section -->
        <div class="analysis-details-section">
            <div class="details-container">
                <h2 class="details-title">DETALLES DEL ANÁLISIS</h2>

                <!-- Gap Indicators -->
                <div class="gap-indicators">
                    <div class="gap-indicator low-gap">
                        <div class="gap-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                <circle cx="12" cy="12" r="10" fill="#28a745" />
                                <text x="12" y="16" text-anchor="middle" fill="white" font-size="14"
                                    font-weight="bold">?</text>
                            </svg>
                        </div>
                        <div class="gap-info">
                            <p class="gap-description">Fortaleza actual, mantener y reforzar y no descuidar.</p>
                            <span class="gap-label">Brecha baja (1 a 3 puntos)</span>
                        </div>
                    </div>

                    <div class="gap-indicator medium-gap">
                        <div class="gap-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                <circle cx="12" cy="12" r="10" fill="#fd7e14" />
                                <text x="12" y="16" text-anchor="middle" fill="white" font-size="14"
                                    font-weight="bold">?</text>
                            </svg>
                        </div>
                        <div class="gap-info">
                            <p class="gap-description">Área con oportunidades importantes de mejora.</p>
                            <span class="gap-label">Brecha media (4 a 6 puntos)</span>
                        </div>
                    </div>

                    <div class="gap-indicator high-gap">
                        <div class="gap-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                <circle cx="12" cy="12" r="10" fill="#dc3545" />
                                <text x="12" y="16" text-anchor="middle" fill="white" font-size="14"
                                    font-weight="bold">?</text>
                            </svg>
                        </div>
                        <div class="gap-info">
                            <p class="gap-description">Oportunidad crítica que requiere acción inmediata.</p>
                            <span class="gap-label">Brecha alta (7 a 9 puntos)</span>
                        </div>
                    </div>
                </div>

                <!-- Mobile Gap Indicators -->
                <div class="gap-indicators-mobile">
                    <div class="gap-indicator-mobile low-gap-mobile">
                        <div class="gap-checkmark">✓</div>
                        <span class="gap-text-mobile">Brecha baja (0 a 3 puntos)</span>
                    </div>

                    <div class="gap-indicator-mobile medium-gap-mobile">
                        <div class="gap-checkmark">✓</div>
                        <span class="gap-text-mobile">Brecha media (4 a 6 puntos)</span>
                    </div>

                    <div class="gap-indicator-mobile high-gap-mobile">
                        <div class="gap-checkmark">✓</div>
                        <span class="gap-text-mobile">Brecha alta (7 a 9 puntos)</span>
                    </div>
                </div>

                <div class="details-table">
                    <div class="table-header">
                        <div class="header-cell">Área</div>
                        <div class="header-cell">Análisis presente</div>
                        <div class="header-cell">Análisis futuro</div>
                        <div class="header-cell">Brecha por cerrar</div>
                    </div>

                    <div class="table-body">
                        <div class="table-row" *ngFor="let area of analysisAreas">
                            <div class="data-cell area-cell">{{ area.name }}</div>
                            <div class="data-cell present-cell">{{ area.present }}</div>
                            <div class="data-cell future-cell">{{ area.future }}</div>
                            <div class="data-cell gap-cell">
                                <span class="gap-pill" [ngClass]="getGapClass(area.gap)">{{ area.gap }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Life Areas Section -->
        <div class="life-areas-section">
            <div class="areas-container">
                <h2 class="areas-title">AREAS DE LA VIDA</h2>
                <p class="areas-description">
                    Este es tu resumen por área de vida: organizado de la mayor a la menor brecha, con consejos
                    prácticos para que empieces a accionar y construir tu plan de vida desde hoy.
                </p>

                <div class="areas-list">
                    <div class="area-item" *ngFor="let area of lifeAreas; let i = index" (click)="toggleArea(i)">
                        <div class="area-content">
                            <div class="area-icon">
                                <img [src]="area.icon" [alt]="area.name" class="area-icon-img">
                            </div>
                            <div class="area-text">
                                <span class="area-name">{{ area.name }}</span>
                            </div>
                            <div class="area-chevron">
                                <i class="fas fa-chevron-right" [class.rotated]="area.expanded"></i>
                            </div>
                        </div>
                        <div class="area-details" *ngIf="area.expanded" [ngClass]="area.gapClass2">
                            <p>{{ area.description }} <a href="javascript:void(0)" (click)="crearPlan()"
                                    class="profile-link">AQUI</a>.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Footer Estático -->
    <div class="static-footer">
        <div class="footer-content">
            <button class="continue-button" (click)="crearPlan()">
                <span>Crear objetivos</span>
                <i class="fas fa-arrow-right"></i>
            </button>
        </div>
    </div>

    <div class="overlay" *ngIf="isShowTutorial"></div>
    <app-tutorial-dialog class="tutorial-dialog" *ngIf="isShowTutorial" [title]="tutorialTitle"
        [description]="tutorialDescription" [currentStep]="tutorialStep" [totalSteps]="tutorialSteps.length"
        [position]="dialogPosition" (continue)="nextStepTutorial()" (skip)="changeShowTutorial()"
        (reset)="resetTutorial()">
    </app-tutorial-dialog>
</div>

<!-- Modal de Lista de Espera -->
<div *ngIf="showWaitlistModal" class="waitlist-modal-overlay">
    <div class="waitlist-modal" (click)="$event.stopPropagation()">
        <div class="waitlist-modal-content">
            <div class="modal-header-text">
                <p>Descubre todo lo que Phoenix Professional tiene para ti</p>
            </div>
            <!-- Sección de Video -->
            <div class="video-section">
                <div class="video-container">
                    <!-- Usar nuestro componente reutilizable YouTube Player -->
                    <div #youtubePlayer>
                        <app-youtube-player *ngIf="getProfessionalVideoId()" [videoId]="getProfessionalVideoId()"
                            [params]="getVideoParams()"></app-youtube-player>
                    </div>

                    <!-- Mensaje de error si no hay video ID -->
                    <div *ngIf="!getProfessionalVideoId()" class="error-message">
                        <p>No se pudo cargar el video profesional</p>
                    </div>
                </div>
            </div>

            <!-- Header Text -->
            <div class="modal-header-text">
                <h2>Únete a nuestra lista de espera para convertirte en Phoenix Professional</h2>
                <p>Sé el primero en acceder a todas las increíbles actividades que tenemos para ti</p>
            </div>

            <!-- Formulario -->
            <form class="waitlist-form" (ngSubmit)="submitWaitlistForm()">
                <div class="form-row">
                    <div class="form-group">
                        <label>Nombre <span class="required">*</span></label>
                        <input type="text" [(ngModel)]="waitlistForm.nombre" name="nombre" placeholder="Ingrese nombre"
                            required>
                    </div>

                    <div class="form-group">
                        <label>Apellido <span class="required">*</span></label>
                        <input type="text" [(ngModel)]="waitlistForm.apellido" name="apellido"
                            placeholder="Ingrese apellido" required>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label>Teléfono <span class="required">*</span></label>
                        <input type="tel" [(ngModel)]="waitlistForm.telefono" name="telefono"
                            placeholder="Ingrese teléfono" required>
                    </div>

                    <div class="form-group">
                        <label>Correo electrónico <span class="required">*</span></label>
                        <input type="email" [(ngModel)]="waitlistForm.correoElectronico" name="correoElectronico"
                            placeholder="Ingrese correo" required>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label>Provincia <span class="required">*</span></label>
                        <select [(ngModel)]="waitlistForm.provincia" name="provincia" (change)="onProvinciaChange()"
                            required>
                            <option value="">Ingrese provincia</option>
                            <option *ngFor="let provincia of provincias" [value]="provincia">
                                {{ provincia }}
                            </option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label>Distrito <span class="required">*</span></label>
                        <select [(ngModel)]="waitlistForm.distrito" name="distrito" [disabled]="!waitlistForm.provincia"
                            required>
                            <option value="">Ingrese distrito</option>
                            <option *ngFor="let distrito of getDistritosByProvincia()" [value]="distrito">
                                {{ distrito }}
                            </option>
                        </select>
                    </div>
                </div>

                <button type="submit" class="register-button"
                    [disabled]="!isWaitlistFormValid() || isSubmittingWaitlist">
                    <span *ngIf="!isSubmittingWaitlist">Registrarme</span>
                    <span *ngIf="isSubmittingWaitlist">Registrando...</span>
                </button>
            </form>

            <!-- Sección de Beneficios -->
            <div class="benefits-section">
                <h3>Descubre todo lo que Phoenix Professional tiene para ti</h3>
                <div class="benefits-list">
                    <div class="benefit-item">
                        <span class="check-icon">✓</span>
                        <span>Sesión grupal mensual para avanzar en comunidad</span>
                    </div>
                    <div class="benefit-item">
                        <span class="check-icon">✓</span>
                        <span>Mentor digital 24/7 disponible para guiarte en cualquier momento.</span>
                    </div>
                    <div class="benefit-item">
                        <span class="check-icon">✓</span>
                        <span>Crea tu plan de vida y define objetivos claros con seguimiento.</span>
                    </div>
                    <div class="benefit-item">
                        <span class="check-icon">✓</span>
                        <span>Acceso completo al directorio de expertos.</span>
                    </div>
                    <div class="benefit-item">
                        <span class="check-icon">✓</span>
                        <span>Acceso a la Academy con contenidos avanzados.</span>
                    </div>
                    <div class="benefit-item">
                        <span class="check-icon">✓</span>
                        <span>Acceso a Phoenix Sessions</span>
                    </div>
                    <div class="benefit-item">
                        <span class="check-icon">✓</span>
                        <span>Rutas de reinvención y herramientas personalizadas para tu progreso.</span>
                    </div>
                </div>
            </div>

            <!-- Botón de cerrar -->
            <button class="close-button" (click)="closeWaitlistModal()">
                <span>×</span>
            </button>
        </div>
    </div>
</div>